import React from "react"

import { Alert, AlertIcon, Text } from "@chakra-ui/react"

// 毎年学年切り替え時に使用するため、一応残しておく
const PromotionAlert = (): JSX.Element => (
  <Alert status="warning" mb={5}>
    <AlertIcon />
    <Text>
      <b>【重要】新学期に伴う学年変更について</b>
      <br />
      先日の広報通り、2024/3/31 22:00～24:00に学年の切り替えを弊社側で実施させていただきました。
      <br />
      <br />
      ※学部４年、修士２年、高専５年、博士全学年、専門全学年の方々や4/1以降の登録者は切り替えの対象外になります。進級・院進など手動でご変更ください。
      <br />
      <br />
      念のため皆様の学年設定を確認いただき、修正が必要な場合は手動でご変更ください。
      <br />
      <br />
      学年・卒業年度に誤りがあると企業スカウトが届かないため、お手数ですがご確認よろしくお願いいたします。
    </Text>
  </Alert>
)

export default PromotionAlert
